import { BaseApi } from './base.api.js';

export class DashboardApi extends BaseApi {
    constructor(client) {
        super(client, '/dashboard');
    }
}
